import React from "react";
import Testimonials from "../../components/services/sections/Testimonials";
import CarouselSlider from "../../components/carousel/CarouselSlider";
import HowItWorksWithSteps from "../../components/services/sections/HowItWorksWithSteps";
import Pricing from "../../components/services/sections/Pricing";
import ServiceSlider from "../../components/services/common/ServiceSlider";
import WhatWhySections from "../../components/services/sections/WhatWhySections";
import {
  individualsData,
  individualsHIWData,
  serviceSliderText,
} from "../../components/services/data";

const Individuals = () => {
  return (
    <>
      <CarouselSlider />
      <WhatWhySections {...individualsData} />
      <HowItWorksWithSteps {...individualsHIWData} />
      <Pricing />
      <Testimonials name="individuals" />
      <ServiceSlider
        header={serviceSliderText.individuals.header}
        subHeader={serviceSliderText.individuals.subHeader}
      />
    </>
  );
};

export default Individuals;
